import { directusApi } from '@/api';

export interface FeedbackInvoicesPDV {
    id: number;
    date_created: string;
    pdv_order: string;
    error_info: string;
    invoice_data?: any;
    feedbacks?: any;
}

export interface FeedbackInvoicePDVState {
    activeFeedbackInvoicePDV: FeedbackInvoicesPDV | null;
    activeFeedbackInvoicePDVLoading: boolean;
    allFeedbackInvoicesPDV: Array<FeedbackInvoicesPDV>;
    allFeedbackInvoicesPDVLoading: boolean;
    invoiceFeedbacksPDVPerPage: number;
    invoiceFeedbacksPDVPage: number;
    invoiceFeedbacksPDVTotal: number;
}

const state: FeedbackInvoicePDVState = {
    activeFeedbackInvoicePDV: {
        id: 0,
        date_created: '',
        pdv_order: '',
        error_info: '',
        invoice_data: {},
        feedbacks: []
    },
    activeFeedbackInvoicePDVLoading: false,
    allFeedbackInvoicesPDV: [],
    allFeedbackInvoicesPDVLoading: false,
    invoiceFeedbacksPDVPerPage: 10,
    invoiceFeedbacksPDVPage: 1,
    invoiceFeedbacksPDVTotal: 0
};

const mutations = {
    toggleAllFeedbackInvoicesPDVLoading(state: FeedbackInvoicePDVState, data: boolean) {
        state.allFeedbackInvoicesPDVLoading = data;
    },
    setAllFeedbackInvoicesPDV(state: FeedbackInvoicePDVState, data) {
        state.allFeedbackInvoicesPDV = data.items;
        state.invoiceFeedbacksPDVPerPage = data.perPage;
        state.invoiceFeedbacksPDVPage = data.currentPage;
        state.invoiceFeedbacksPDVTotal = data.totalItems;
    },
    toggleActiveFeedbackInvoicePDVLoading(state: FeedbackInvoicePDVState, data: boolean) {
        state.activeFeedbackInvoicePDVLoading = data;
    },
    setActiveFeedbackInvoicePDV(state: FeedbackInvoicePDVState, data: FeedbackInvoicesPDV) {
        state.activeFeedbackInvoicePDV = data;
    },
};

const actions = {
     async getAll({ commit }, { search, page, status_filter, start_date, end_date }) {
        commit('toggleAllFeedbackInvoicesPDVLoading', true);
        try {
            const limit = 10;
            const currentPage = page || 1;
            const offset = (currentPage - 1) * limit;
            
            // ✅ Construir URL correctamente
            let url = `custom/api/get_invoices?limit=${limit}&offset=${offset}`;
            
            if (start_date && end_date) {
                url += `&start_date=${start_date}&end_date=${end_date}`;
            }
            
            if (search) {
                url += `&search=${search}`;
            }
            
            const res = await directusApi('GET', url);
            
            // Agregar variant a cada item según el status
            const invoicesWithVariant = res.data.data.map(invoice => ({
                ...invoice,
                variant: invoice.status === 'Finalizada' ? 'success' : 'danger'
            }));

            const payload = {
                items: invoicesWithVariant,
                perPage: limit,
                currentPage: Number(currentPage),
                totalItems: res.data.meta.filter_count, // ✅ Acceder correctamente al total
            };

            commit('setAllFeedbackInvoicesPDV', payload);
            
        } catch (err) {
            console.error('Error al obtener facturas PDV:', err);
        } finally {
            commit('toggleAllFeedbackInvoicesPDVLoading', false);
        }
    },
    async getOne({ _, commit, dispatch }: any, id: any | null = null) {
            commit('toggleActiveFeedbackInvoicePDVLoading', true);
            let feedbacks = [];
            let invoice_info: any = {};
            let res = await directusApi('GET', `items/feedback_invoices_pdv?fields=pdv_order,date_created,error_info&filter[pdv_order][_eq]=${id}`)
            let info = await directusApi('GET', `items/pdv_xml?fields=data,date_created,xml&filter[order][_eq]=${id}`)

            invoice_info.id = id;
            for(let attempt of res.data.data){
                feedbacks.unshift(attempt)
            }
            invoice_info.feedbacks = feedbacks
            invoice_info.invoice_data = info.data.data[info.data.data.length - 1].data
            invoice_info.date_created = info.data.data[info.data.data.length - 1].date_created
            commit('setActiveFeedbackInvoicePDV', invoice_info);
            commit('toggleActiveFeedbackInvoicePDVLoading', false);
        },
        async sendInvoice({ _, commit, dispatch }: any, data : any | null) {
        commit('toggleActiveFeedbackInvoicePDVLoading', true);
        let id = data.id;
        let emails = data.emails;
        await directusApi('POST', 'custom/invoice/pdv_resend_invoice', { id, emails }).then(async res => {
            if (res.data.data.includes('Lo sentimos')) {
                data.view.$bvToast.toast(res.data.data, {
                    title: `Lo sentimos 😥 `,
                    variant: 'warning',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            } else {
                data.view.$bvToast.toast(res.data.data, {
                    title: `Documentos reenviados correctamente 😎`,
                    variant: 'success',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
            }
        }).catch(err => {
            console.log(err);
        }).finally(() => {
            commit('toggleActiveFeedbackInvoicePDVLoading', false);
        });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
